<template>
    <TabWrapper @save="submit" @change="change" @deploy:preview="$emit('deploy:preview')"
                @deploy:live="$emit('deploy:live')">
        <v-container fluid>
            <v-row justify="center">
                <v-col cols="12" lg="10">
                    <v-row no-gutters>
                        <Toggle
                            v-model="blockerEnabled"
                            label="Blocker aktiv"
                            class="mr-6"
                            :disabled="readOnly"
                        >
                        </Toggle>
                    </v-row>
                    <v-row no-gutters>
                        <Textarea label="Beschreibung" v-model="blockerMessage" :disabled="readOnly"></Textarea>
                    </v-row>
                </v-col>
            </v-row>
        </v-container>
    </TabWrapper>
</template>

<script>
import TabWrapper from "./TabWrapper";
import ada from "../../../scss/ada_colors.scss";
import Textarea from "../../../components/Inputs/Textarea";
import Toggle from "../../../components/buttons/Toggle";

export default {
    name: "Blocking",
    components: {Toggle, Textarea, TabWrapper},
    props: ['readOnly'],
    data: () => {
        return {
            blockerEnabled: 0,
            blockerMessage: '',
            ada
        }
    },
    mounted() {
        this.init();
        this.$emit('activeComponent', this);
    },
    computed: {
        vuexState() {
            return this.$store.state.display;
        },
        siteDetails() {
            return this.vuexState.siteDetails;
        },
        activeTab() {
            return this.$store.state.display.activeTab;
        }
    },
    methods: {
        init() {
            if (this.siteDetails) {
                this.blockerEnabled = this.siteDetails.Current.BlockerEnabled;
                this.blockerMessage = this.siteDetails.Current.BlockerMessage;
            }
        },
        submit() {
            this.$emit('submit', this);
        },
        change() {
            if (this.$store.state.display.previousTab === this.$options._componentTag) {
                this.$emit('change', this);
            } else if (this.activeTab === this.$options._componentTag) {
                this.$emit('activeComponent', this);
            }
        },
        dataChanged() {
            let changed = false;
            if (this.blockerEnabled !== this.siteDetails.Current.BlockerEnabled ||
                this.blockerMessage !== this.siteDetails.Current.BlockerMessage) {
                changed = true;
            }
            return changed;
        },
        getBody() {
            return {
                publisher_id: this.siteDetails.Site.PublisherId,
                site_id: this.siteDetails.Site.SiteId,
                type_id: this.siteDetails.Current.SitetypeId,
                BlockerMessage: this.blockerMessage,
                BlockerEnabled: this.blockerEnabled
            }
        },
    },
    watch: {
        siteDetails() {
            this.init();
        }
    }

}
</script>

<style scoped>

</style>